import styled, { css } from 'styled-components';


export const Wrapper = styled.article``;

export const Content = styled.div`
  ${({ theme }) => css`
    font-family: ${theme.v2.font.family.primary};
    line-height: ${theme.v2.font.lineHeight.text};
    color: ${theme.v2.colors.neutral.lowDark};
    padding: 0;
  `}
`;

export const Header = styled.header``;

export const Title = styled.h1`
  ${({ theme }) => css`
    color: ${theme.v2.colors.neutral.lowDark};
    font-family: ${theme.v2.font.family.primary};
    font-weight: ${theme.v2.font.weights.medium};
    font-size: ${theme.v2.font.sizes.md};
    margin: 0 0 24px 0;
    padding: 0;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    padding: 0;
    margin: 0 0 16px 0;

    p {
      margin: 8px 0 0 0;
    }    
  `}    
`;

export const InputsWrapper = styled.div`
  list-style: none;
  margin: 24px 0 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 16px;
  align-items: flex-start;  
`;

export const CheckboxLabel = styled.label`
  ${({ theme }) => css`
    cursor: pointer;
    display: inline-flex;
    align-items: flex-start;
    margin: 0;

    button {
      padding: 2px 8px 0px 0px;
    }

    label {
      border-radius: 4px;
      width: 16px;
      height: 16px;      

      svg {
        fill: ${theme.v2.colors.neutral.highPure};
        stroke: ${theme.v2.colors.neutral.highPure};
        flex: 0 0 12px;
        border-radius: 4px;
      }
    }
    
    input:checked ~ label {
      background-color: ${theme.v2.colors.brand.primaryMedium};
      border-color: ${theme.v2.colors.brand.primaryMedium} !important;
    }
  `}
`;

export const Text = styled.span`
  ${({ theme }) => css`
    font-size: ${theme.v2.font.sizes.xs};
    color: ${theme.v2.colors.neutral.lowDark};
    line-height: ${theme.v2.font.lineHeight.text};
    user-select: none;
  `}
`;

export const Controls = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 24px;
`;
